module.exports = __webpack_public_path__ + "img/itx-file-type-docx.c30787a5.svg";